import { useEffect } from "react";

import { MenuItem, TextField } from "@material-ui/core/";

import Calendar from "../../../assets/icons/Calendar.svg";

import { Container, makeStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Autocomplete } from "@material-ui/lab";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { counter, counter2 } from "../../../constants/constants";
import { useGlobal } from "../../../contexts/globalContext";
import HotelRepository from "../../../repositories/hotelRepository";
import cleanStorageBeforeSearch from "../../../utils/cleanStorageBeforeSearch";
import { validateAllRooms } from "../../../utils/validator";
import ChooseChidsAge from "../../ChooseChidsAge";
import ChoosePackageRooms from "../../ChoosePackageRooms";
import IconedInput from "../../IconedInput";
import InputDateRange from "../../InputDateRange";
import ThemeButton from "../../ThemeButton";
import * as S from "./styles";

import { getSessionStorage } from "../../../utils/getSessionStorage";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormHelperText-root.Mui-error": {
      color: "white",
    },
    opacity: 1,
    "& .MuiInputBase-input": {
      color: `#FFF`,
    },
    "& label.Mui-focused": {
      color: `#FFF`,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: `#FFF`,
      color: `#FFF`,
    },
    "& .MuiFormLabel-root": {
      color: "#FFF",
      opacity: 0.45,
    },
    "& .MuiSelect-icon": {
      color: "#FFF",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
      },
      "&:hover fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
        borderWidth: 2,
      },
      "&.Mui-focused fieldset": {
        borderColor: `#FFF`,
        color: `#FFF`,
      },
      "&.Mui-error fieldset": {
        borderColor: "#FFF",
      },
    },
  },
}));
const HotelSearchInputs = () => {
  const { showAlert /**, signed **/, user } = useGlobal();
  let history = useHistory();
  const classes = useStyles();
  const hotelRepository = new HotelRepository();

  const initialState = {
    cidade: "",
    datas: "",
    qtAdult: 1,
    qtChild: 0,
    qtRooms: 1,
  };
  const [state, setState] = useState(initialState);
  const [options, setOptions] = useState([]);
  const [send, setSend] = useState(false);
  const [openModalChild, setOpenModalChild] = useState(false);
  const [openRoomModal, setOpenRoomModal] = useState(false);

  useEffect(() => {}, [state]);

  const numberOfPeople = () => {
    return counter.map((count, index) => (
      <MenuItem key={index} value={count}>
        {count}
      </MenuItem>
    ));
  };

  const numberOfRooms = () => {
    return counter2.map((count, index) => (
      <MenuItem key={index} value={count}>
        {count}
      </MenuItem>
    ));
  };

  const changeOptions = (value) => {
    if (value.length >= 3) {
      hotelRepository.searchAutoComplete(value).then((res) => {
        // A resposta é um array de HotelLocationModel[]
        // { id, name, type, state, country }
        const locations = res?.data || [];

        // Formata as localizações para o formato esperado pelo componente
        const formattedLocations = locations.map((loc) => ({
          ...loc,
          cityName: loc.name,
          code: loc.id,
          parentName: loc.state,
          country: loc.country,
          // type pode ser 'destination' ou 'hotel' dependendo do backend
          type: loc.type || 'destination',
          hotelId: loc.type === 'hotel' ? loc.id : undefined,
        }));

        setOptions(formattedLocations);
      }).catch((err) => {
        console.error('Erro ao buscar localizações:', err);
        setOptions([]);
      });
    }
  };

  const handleChangeChildsAge = (age) => {
    setState({ ...state, childAge: Object.values(age) });
  };

  const handleRoomModalConfirm = (roomData) => {
    setState({
      ...state,
      qtRooms: roomData.qtRooms,
      qtAdult: roomData.qtAdult,
      qtChild: roomData.qtChild,
      childAge: roomData.childAge || [],
      apartments: roomData.apartments,
    });
  };

  const handleSubmit = () => {
    // if (signed) {
    setSend(true);

    const totalPassengers = state.qtAdult + state.qtChild;
    if (totalPassengers > 9) {
      showAlert(
        "warning",
        "Ops! Para grupos acima de 9 pessoas, nosso time de especialistas entra em ação! Entre em contato e descubra opções personalizadas para sua viagem."
      );
      history.push("/plantrip");
      return;
    }

    if (state.apartments) {
      const roomValidation = validateAllRooms(state.apartments);
      if (!roomValidation.valid) {
        showAlert(
          "error",
          `O quarto ${roomValidation.roomIndex + 1} possui ${
            roomValidation.totalGuests
          } hóspedes. O máximo permitido é de 4 pessoas por quarto.`
        );
        return;
      }
    }

    if (
      state.cidade === "" ||
      state.datas === "" ||
      state.qtRooms === 0 ||
      (state.qtAdult === 0 && state.qtChild === 0)
    ) {
      showAlert("error", "Por favor, preencha todos os campos");
    } else {
      cleanStorageBeforeSearch();
      sessionStorage.setItem("hotelSearch", JSON.stringify(state));
      sessionStorage.setItem("buscaAtual", "Hotel");
      history.push("/busca/resultado-pesquisa");
    }
    // } else {
    //   showAlert('error', 'Efetue o login para realizar a busca');
    // }
  };

  useEffect(() => {
    if (state !== initialState) {
      sessionStorage.setItem("hotelSearch", JSON.stringify(state));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  useEffect(() => {
    const hotel = getSessionStorage("hotelSearch");
    if (hotel) setState(hotel);
  }, []);

  return (
    <S.Wrapper>
      <ChooseChidsAge
        open={openModalChild}
        onClose={() => setOpenModalChild(false)}
        qtdChilds={state?.qtChild}
        setQtChilds={(qt) => setState({ ...state, qtChild: qt })}
        handleChangeChildsAge={handleChangeChildsAge}
      />
      <ChoosePackageRooms
        open={openRoomModal}
        onClose={setOpenRoomModal}
        onConfirm={handleRoomModalConfirm}
        initialRooms={state.qtRooms}
        initialAdults={state.qtAdult}
        initialChildren={state.qtChild}
      />
      <Container>
        <div className="origem-destino-control">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3} lg={4}>
              <Autocomplete
                freeSolo
                disableClearable
                className={classes.root}
                noOptionsText="Não encontrado"
                options={options}
                getOptionLabel={(option) =>
                  option
                    ? `${option.cityName}${
                        option.parentName ? `, ${option.parentName}` : ""
                      }${option.country ? `, ${option.country}` : ""}`
                    : ""
                }
                onInputChange={(event, value, reason) => {
                  if (reason === "input") {
                    changeOptions(value);
                  }
                }}
                onChange={(event, newValue) => {
                  setState({ ...state, cidade: newValue });
                }}
                filterOptions={(x) => x}
                value={state.cidade !== "" ? state.cidade : ""}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Destino"
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                    error={send && state.cidade === initialState.cidade}
                    helperText={
                      send && state.cidade === initialState.cidade
                        ? "Cidade não pode ser vazia"
                        : ""
                    }
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={2}>
              <InputDateRange
                icon={Calendar}
                label="Data entrada/saida"
                width={190}
                value={state.datas.abreviada}
                onChange={(e) => setState({ ...state, datas: e })}
                error={send && state.datas === initialState.datas}
                helperText={
                  send && state.datas === initialState.datas
                    ? "Data não pode ser vazia"
                    : ""
                }
                minStartDays={Math.max(user.campaign.advanceDaysHotel || 0, 3)}
              />
            </Grid>
            <Grid className="search-divider" item xs={12} sm={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs>
                  <IconedInput
                    value={`${state.qtRooms} quarto${
                      state.qtRooms > 1 ? "s" : ""
                    }, ${state.qtAdult + state.qtChild} hóspede${
                      state.qtAdult + state.qtChild > 1 ? "s" : ""
                    }`}
                    label="Quartos"
                    width={150}
                    onClick={() => setOpenRoomModal(true)}
                    readOnly={true}
                    error={send && state.qtRooms === 0}
                    helperText={
                      send && state.qtRooms === 0
                        ? "Selecione pelo menos 1 quarto"
                        : ""
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={3}>
                  <ThemeButton onClick={handleSubmit} className="submit1">
                    Buscar
                  </ThemeButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Container>
    </S.Wrapper>
  );
};

export default HotelSearchInputs;
